interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry: () => void;
}

export default function ErrorState({
  title = "网络加载失败",
  description = "请检查网络连接后重试，或稍后再来访问。",
  onRetry,
}: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4">
      <span className="flex items-center justify-center w-16 h-16 rounded-full bg-secondary-100 text-secondary-600 mb-4">
        <i className="ri-wifi-off-line text-3xl" />
      </span>
      <h3 className="text-base md:text-lg font-semibold text-foreground-900">{title}</h3>
      <p className="mt-1.5 text-sm text-foreground-500 max-w-md">{description}</p>
      <button
        type="button"
        onClick={onRetry}
        className="mt-5 inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
      >
        <i className="ri-refresh-line" />
        <span>重新加载</span>
      </button>
    </div>
  );
}